// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__QD7F6","header":"MergedInvoice_header__2z8w2"};